import React, { createContext, useContext, useState } from "react";
import translations from "../i18n/translations";

const IdiomaContext = createContext(null);

const IDIOMAS_VALIDOS = ["es", "de", "en"];

export const IdiomaProvider = ({ children }) => {
  const [idioma, setIdiomaState] = useState(() => {
    const guardado = localStorage.getItem("idioma");
    return IDIOMAS_VALIDOS.includes(guardado) ? guardado : "es";
  });

  const setIdioma = (nuevo) => {
    if (!IDIOMAS_VALIDOS.includes(nuevo)) return;
    localStorage.setItem("idioma", nuevo);
    setIdiomaState(nuevo);
  };

  const t = (key) => translations[idioma]?.[key] ?? translations.es[key] ?? key;

  return (
    <IdiomaContext.Provider value={{ idioma, setIdioma, t }}>
      {children}
    </IdiomaContext.Provider>
  );
};

// Fallback a español si algún componente se usa fuera del provider
// (ej. GradosCDA también se monta en la ruta pública "/grados-cda").
export const useIdioma = () => {
  const ctx = useContext(IdiomaContext);
  if (ctx) return ctx;
  return {
    idioma: "es",
    setIdioma: () => {},
    t: (key) => translations.es[key] ?? key,
  };
};
